import { getActivePinia, storeToRefs, } from 'pinia'
import { LOADED, usePrefetchData, } from '@/assets/js/src/util/composables/usePrefetchData'
import { useHelpItemStore, } from '@/assets/js/src/modules/help/_pinia/helpItem'
import { useRoute, } from 'vue-router'
import { computed, watch, ref, onUnmounted, } from 'vue'
import { safeDecodeURI, } from '@/assets/js/src/util/safeDecodeURI'

export function useHelpItemApi () {
    let helpItemStore = useHelpItemStore(getActivePinia())

    const { helpItem,children, } = storeToRefs(helpItemStore)

    let route = useRoute()
    
    const { messagesLoaded, asyncStatus, updateData, } = usePrefetchData({
        actions: [
            {
                item: helpItem,
                action: helpItemStore.getHelpItem,
                payload: function () {
                    return {
                        id: route.params.id,
                    }
                },
            },
        ],
        loadAsyncMessages: [ 'help', 'common', ],
    })

    let scrollTo = ref('')
    watch(() => route.params.id,
        ()=>{
            if (route.hash && route.hash.trim() !== '') {
                scrollTo.value = safeDecodeURI(route.hash.replace('#', ''))
            }
            updateData(true)
        })

    const asyncStatusLoaded = computed(()=>asyncStatus.value === LOADED)

    onUnmounted(()=>{
        helpItem.value = {}
        children.value = []
    })
    
    return {
        helpItem,
        children,
        messagesLoaded,
        asyncStatusLoaded,
        scrollTo,
    }
}
